import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var M = Object.defineProperty,
    y = Object.defineProperties;
var P = Object.getOwnPropertyDescriptors;
var s = Object.getOwnPropertySymbols;
var m = Object.prototype.hasOwnProperty,
    c = Object.prototype.propertyIsEnumerable;

var d = function d(o, e, t) {
  return e in o ? M(o, e, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: t
  }) : o[e] = t;
},
    p = function p(o, e) {
  for (var t in e || (e = {})) {
    m.call(e, t) && d(o, t, e[t]);
  }

  if (s) {
    var _iterator = _createForOfIteratorHelper(s(e)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var t = _step.value;
        c.call(e, t) && d(o, t, e[t]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return o;
},
    u = function u(o, e) {
  return y(o, P(e));
};

var f = function f(o, e) {
  var t = {};

  for (var a in o) {
    m.call(o, a) && e.indexOf(a) < 0 && (t[a] = o[a]);
  }

  if (o != null && s) {
    var _iterator2 = _createForOfIteratorHelper(s(o)),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var a = _step2.value;
        e.indexOf(a) < 0 && c.call(o, a) && (t[a] = o[a]);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return t;
};

import r, { useState as x, useEffect as N } from "react";
import b from "react-modal";
import v from "classnames";
import { IconButton as A } from "../icon-button";
import { Card as B, CardContent as F } from "@material-ui/core";
import { motion as O, AnimatePresence as S } from "framer-motion";
import "./modal.css";

var D = function D(k) {
  var n = k,
      _n$isOpen = n.isOpen,
      o = _n$isOpen === void 0 ? !1 : _n$isOpen,
      e = n.className,
      _n$closeButton = n.closeButton,
      t = _n$closeButton === void 0 ? !0 : _n$closeButton,
      a = n.children,
      C = f(n, ["isOpen", "className", "closeButton", "children"]);

  var _x = x(o),
      _x2 = _slicedToArray(_x, 2),
      i = _x2[0],
      l = _x2[1];

  return N(function () {
    l(o);
  }, [o]), r.createElement(b, u(p({}, C), {
    isOpen: i,
    className: v("lc-modal", e),
    closeTimeoutMS: 500
  }), r.createElement(S, null, i ? r.createElement(O.div, {
    initial: {
      opacity: 0,
      scale: 1.25,
      y: -20
    },
    animate: {
      opacity: 1,
      scale: 1,
      y: 0
    },
    transition: {
      ease: "easeOut",
      duration: .5
    },
    exit: {
      opacity: 0,
      scale: .8,
      y: 20,
      transition: {
        ease: "easeOut"
      }
    }
  }, r.createElement(B, null, t ? r.createElement(A, {
    className: "lc-modal-close",
    icon: "close",
    onClick: function onClick() {
      return l(!1);
    }
  }) : null, r.createElement(F, null, a))) : null));
};

export { D as Modal };